export const onlyDecimals = e => {
  let k = e.keyCode
  if ((k >= 48 && k <= 57) || k === 8 || k === 110 || k === 190 || k === 37 || k === 39 || (k >= 96 && k <= 105)) {
    return true
  } else {
    e.preventDefault()
  }
}

export const onlyNumbers = e => {
  let k = e.keyCode
  if ((k >= 48 && k <= 57) || k === 8 || k === 37 || k === 39 || (k >= 96 && k <= 105)) {
    return true
  } else {
    e.preventDefault()
  }
}
export const stringToJson = string => {
  if (string) {
    return JSON.stringify(string.split(','))
  } else {
    return null
  }
}

export const jsonImage = (data, size = 'small') => {
  return data.images[size][0]
}



// WEBPACK FOOTER //
// ./src/assets/js/libs/functions.js